define([
	"dojo/_base/declare",
	"dojo/dom-style",
	"dojo/on",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/form/Button",
	"dijit/form/Form",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/message",
	"dojo/text!./EmailForm.html",
	"csi/widget/froalaTextEditor",
	"csi/widget/EmailFormListField"
], function(declare,domStyle,on,_TemplatedMixin,_WidgetsInTemplateMixin,Button,Form,_,html,locale,message,template) {

	return declare([Form, _TemplatedMixin, _WidgetsInTemplateMixin], {
        // Boolean: allow addition of arbitrary email addresses
        allowArbitraryEmailAddresses: true,

		// base widget members
		templateString: template,

		// DOMNode: attach points
		subjectNode: null,
		messageNode: null,
		toUsersNode: null,
		ccUsersNode: null,
		bccUsersNode: null,
		attachmentsNode: null,
		attachmentsRowNode: null,

		postCreate: function() {
			this.toUsersNode.selectNode.addNewItem = this.allowArbitraryEmailAddresses;
			this.ccUsersNode.selectNode.addNewItem = this.allowArbitraryEmailAddresses;
			this.bccUsersNode.selectNode.addNewItem = this.allowArbitraryEmailAddresses;
		},

		getRecipientWidgets: function() {
			// summary: return an array of EmailFormListField widgets responsible for selecting recipients
			return [this.toUsersNode, this.ccUsersNode, this.bccUsersNode];
		},

		setUsersStore: function(store) {
			_.forEach(this.getRecipientWidgets(), function(widget){
				widget.set("store", store);
			});
		},

		setAttachmentsStore: function(store) {
			this.attachmentsNode.set("store", store);
			html.setVisible(this.attachmentsRowNode, Boolean(store));
		},

		validate: function() {
			// summary: make sure at least one recipient is selected
			if (!this.inherited(arguments))
				return false;

			var isValid = _.some(this.getRecipientWidgets(), function(widget) {
				var value = widget.get("value");
				return value && value.length > 0;
			});

			if (!isValid) {
				message.errorDialog({
					message: locale.resource("EmailErrorUsers")
				});
			}

			return isValid;
		},
		
		/*Email widget is inherited from dijit form, which does not have "focus()" method.This seems to be dojo's bug, 
		And since that we can't fix it directly and this is why we are adding dummy function*/
		focus: function() { },
		
		onFocus: function(){
			this.inherited(arguments);
			// Focus first child. We don't use tabIndex for this, as Froala must have tabIndex == 1 (C8-8065)
			if (!this._wasFocused){
				this.getChildren()[0].selectNode.focus();
				this._wasFocused = true;
			}
		}
	});
});